export default __webpack_public_path__ + "static/media/girl3.a4a9f328.png";